/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Returns an array element.
*
* ## Notes
*
* -   The number of indices should **equal** the number of dimensions. Accordingly, for zero-dimensional arrays, no indices should be provided.
*
* @private
* @param {...integer} idx - indices
* @returns {*} array element
*/
function get() {
	/* eslint-disable no-invalid-this */
	var idx;
	var i;

	idx = this._offset;
	for ( i = 0; i < arguments.length; i++ ) {
		idx += this._strides[ i ] * arguments[ i ];
	}
	if ( this._accessors ) {
		return this._buffer.get( idx );
	}
	return this._buffer[ idx ];
}


// EXPORTS //

module.exports = get;
